<template>
  <footer class="app-footer">
    &copy; 2023 clinico.
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?11dafd0e